import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import HomePage from "@/components/HomePage";
import ProductsPage from "@/components/ProductsPage";
import ProductDetailPage from "@/components/ProductDetailPage";
import CartPage from "@/components/CartPage";
import AboutPage from "@/components/AboutPage";
import ContactPage from "@/components/ContactPage";
import LogoPreviewPage from "@/components/LogoPreviewPage";
import ThanksgivingGreeting from "@/components/ThanksgivingGreeting";
import SeasonalGreeting from "@/components/SeasonalGreeting";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";
import ProtectedAdminRoute from "@/components/admin/ProtectedAdminRoute";
import { CartProvider } from "@/context/CartContext";

function App() {
  return (
    <CartProvider>
      <div className="App min-h-screen flex flex-col bg-gray-50">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Logo preview page - no header/footer */}
            <Route path="/logo-preview" element={<LogoPreviewPage />} />
            
            {/* Thanksgiving greeting - no header/footer (legacy direct route) */}
            <Route path="/thanksgiving" element={<ThanksgivingGreeting />} />

            {/* Dynamic seasonal greetings (admin-managed) - no header/footer */}
            <Route path="/greetings" element={<SeasonalGreeting />} />

            {/* Admin routes - no header/footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
            
            {/* Regular pages with header/footer */}
            <Route path="/" element={
              <>
                <Header />
                <main className="flex-grow"><HomePage /></main>
                <Footer />
              </>
            } />
            <Route path="/products" element={
              <>
                <Header />
                <main className="flex-grow"><ProductsPage /></main>
                <Footer />
              </>
            } />
            <Route path="/products/:productId" element={
              <>
                <Header />
                <main className="flex-grow"><ProductDetailPage /></main>
                <Footer />
              </>
            } />
            <Route path="/cart" element={
              <>
                <Header />
                <main className="flex-grow"><CartPage /></main>
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Header />
                <main className="flex-grow"><AboutPage /></main>
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Header />
                <main className="flex-grow"><ContactPage /></main>
                <Footer />
              </>
            } />
          </Routes>
        </BrowserRouter>
      </div>
    </CartProvider>
  );
}

export default App;